import styled from 'styled-components';

export const Wrapper = styled.div`
  
  padding: 1.6rem;
  background-color: ${(props) => props.theme.colors.darkBlue};
  text-align: center;
  border-radius: inherit;
  color: ${(props) => props.theme.colors.white100};

`;